import "./Details.css";

import { ArrowheadLeftLightIcon } from "../../../../../assets";
import { Button, ErrorBox, ProjectDetailsWizard } from "../../../../../widget";
import { useDetails } from "./useDetails";

const Details = (): JSX.Element => {
  const {
    steps,
    selectedStep,
    stepFields,
    hasPreviousStep,
    hasNextStep,
    isStepNavigationLoading,
    errors,
    handleMoveToStep,
    handleMoveToNextStep,
    handleMoveToPreviousStep,
  } = useDetails();

  return (
    <div className="ProjectTabSection ProjectDetailsTab">
      <div className="ProjectDetailsTabWizardContainer">
        <ProjectDetailsWizard steps={steps} handleMoveToStep={handleMoveToStep} />
      </div>
      <div className="ProjectDetailsTabFieldsContainer">
        {selectedStep && (
          <>
            <div className="ProjectDetailsTabFieldsContent">
              <p className="body01">{selectedStep.label}</p>
              {errors && errors.length > 0 && (
                <div className="ProjectDetailsTabErrorBox">
                  <ErrorBox
                    title="Please solve the below issues before continuing"
                    text={errors.map((error) => error.message)}
                  />
                </div>
              )}
              {stepFields}
            </div>
            <div className="ProjectDetailsTabNavigationButtons">
              {hasPreviousStep && (
                <Button
                  text="Previous"
                  variant="tertiary"
                  hasNoPadding
                  icon={<ArrowheadLeftLightIcon className="ProjectDetailsTabPreviousIcon" />}
                  iconPosition="left"
                  onClick={handleMoveToPreviousStep}
                  corners="rounded"
                  size="smallLarge"
                  isLoading={isStepNavigationLoading}
                />
              )}
              {hasNextStep && (
                <Button
                  text="Next"
                  variant="primary"
                  hasNoPadding
                  icon={<ArrowheadLeftLightIcon className="ProjectDetailsTabNextIcon" />}
                  onClick={handleMoveToNextStep}
                  corners="rounded"
                  size="smallLarge"
                  isLoading={isStepNavigationLoading}
                />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Details;
